import { createAsyncThunk } from "@reduxjs/toolkit";
import {  getTermAndCandition } from "helpers/backend_helper";

export const getTermAndCanditionThunk = createAsyncThunk(
  "policy/getPrivacyPolicy",
  async (
    { type, isBuyPassPolicy }: { type: string; isBuyPassPolicy: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await getTermAndCandition(type, isBuyPassPolicy);
      return response;
    } catch (error) {
      return rejectWithValue("Something went wrong!");
    }
  }
);
